import React, {createContext} from 'react'

const GeneralContext = createContext({})

const GeneralProvider = ({children}) => {
  const [mobileMenuState, setMobileMenuState] = React.useState(false)
  const [generalSetupMenuMobileState, setGeneralSetupMenuMobileState] = React.useState(false)

  const toggleMobileMenuDrawer = (event) => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return
    }
    setMobileMenuState(!mobileMenuState)
  }

  const toggleGeneralSetupMobileMenuDrawer = (event) => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return
    }
    setGeneralSetupMenuMobileState(!generalSetupMenuMobileState)
  }

  return (
    <GeneralContext.Provider value={{
      mobileMenuState,
      setMobileMenuState,
      generalSetupMenuMobileState,
      toggleGeneralSetupMobileMenuDrawer,
      toggleMobileMenuDrawer
    }}>
      {children}
    </GeneralContext.Provider>
  )
}
const GeneralConsumer = GeneralContext.Consumer

export {GeneralProvider, GeneralConsumer}
